import React, { createContext, useContext, useState, useEffect } from 'react';
import { getProfile } from '../services/profileService';
import { useAuth } from '../components/Providers/Auth/AuthContext';

const ProfileContext = createContext(null);

export const useProfile = () => useContext(ProfileContext);

export const ProfileProvider = ({ children }) => {
  const [profile, setProfile] = useState(null);
  const [isReady, setIsReady] = useState(false);

  // Use the useAuth hook instead of useContext directly
  const { token } = useAuth();

  useEffect(() => {
    const fetchProfile = async () => {
      // If no token, user is not logged in
      if (!token) {
        setProfile(null);
        setIsReady(true);
        return;
      }

      // If token exists, fetch profile
      try {
        const data = await getProfile();
        setProfile(data);
      } catch (error) {
        console.error('Error fetching profile:', error);
        setProfile(null);
      } finally {
        setIsReady(true);
      }
    };

    fetchProfile();
  }, [token]);

  // Show loading only while fetching profile (when token exists)
  // This allows login page to render immediately when no token
  if (!isReady && token) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return <ProfileContext.Provider value={profile}>{children}</ProfileContext.Provider>;
};
